import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "../styles/Navbar.css";
import { useLanguage } from "../contexts/LanguageContext";

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [activeSection, setActiveSection] = useState("hero");
    const navigate = useNavigate();
    const { language, toggleLanguage } = useLanguage();

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
            setActiveSection(id);
        }
        setIsMenuOpen(false);
    };



    // Navbar content based on language
    const navContent = {
        brand: {
            english: "Tamizhaga Vetri Kazhagem",
            tamil: "தமிழக வெற்றிக் கழகம்"
        },
        branddes: {
            english: "For all life, from birth to death",
            tamil: "பிறப்பொக்கும் எல்லா உயிர்க்கும்"
        },
        home: {
            english: "Home",
            tamil: "முகப்பு"
        },
        about: {
            english: "About Us",
            tamil: "எங்களை பற்றி"
        },
        mission: {
            english: "Mission & Vision",
            tamil: "குறிக்கோள் & பார்வை"
        },
        contact: {
            english: "Contact us",
            tamil: "தொடர்பு"
        },
        joinParty: {
            english: "Join Party",
            tamil: "கட்சியில் சேருங்கள்"
        },
        menu: {
            english: "Menu",
            tamil: "பட்டி"
        }
    };

    return (
        <nav className="navbar">
            <div className="navbar-container">

                {/* LOGO */}
                <div className="logo-container" onClick={() => navigate("/")}>
                    <img src="/assets/tvkimages/image 4.png" alt="Logo" />
                    <div className="moto">
                        <h1>{navContent.brand[language]}</h1>
                        <p>{navContent.branddes[language]}</p>
                    </div>
                </div>

                {/* DESKTOP NAV */}
                <div className="nav-links desktop-nav">
                    <NavLink onClick={() => scrollToSection("hero")} >
                        {navContent.home[language]}
                    </NavLink>
                    <NavLink onClick={() => scrollToSection("about")}>
                        {navContent.about[language]}
                    </NavLink>
                    <NavLink onClick={() => scrollToSection("mission")}>
                        {navContent.mission[language]}
                    </NavLink>
                    <NavLink onClick={() => scrollToSection("contact")}>
                        {navContent.contact[language]}
                    </NavLink>

                    {/* <NavLink to="/Contact">
            <span className="highlight">
              {navContent.joinParty[language]}
            </span>
          </NavLink> */}
                </div>
                <div className="teamtog">

                    {/* Language Toggle Button */}
                    <button
                        className="language-toggle"
                        onClick={toggleLanguage}
                        title={language === 'tamil' ? 'Switch to English' : 'தமிழுக்கு மாற்று'}
                    >
                        {language === 'tamil' ? 'English' : 'தமிழ்'}
                    </button>

                    {/* MOBILE TOGGLE */}
                    <button
                        className={`menu-toggle ${isMenuOpen ? "active" : ""}`}
                        onClick={() => setIsMenuOpen(true)}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </div>
            </div>

            {/* OVERLAY */}
            <div
                className={`mobile-menu-overlay ${isMenuOpen ? "active" : ""}`}
                onClick={() => setIsMenuOpen(false)}
            ></div>

            {/* MOBILE NAV */}
            <div className={`mobile-nav ${isMenuOpen ? "active" : ""}`}>
                <div className="mobile-nav-header">
                    <h3>{navContent.menu[language]}</h3>
                    <button className="close-menu" onClick={() => setIsMenuOpen(false)}>
                        &times;
                    </button>
                </div>

                <div className="mobile-nav-links">

                    <NavLink
                        className={`mobile-link ${activeSection === "hero" ? "active" : ""}`}
                        onClick={() => scrollToSection("hero")}
                    >
                        {navContent.home[language]}
                    </NavLink>

                    <NavLink
                        className={`mobile-link ${activeSection === "about" ? "active" : ""}`}
                        onClick={() => scrollToSection("about")}
                    >
                        {navContent.about[language]}
                    </NavLink>

                    <NavLink
                        className={`mobile-link ${activeSection === "mission" ? "active" : ""}`}
                        onClick={() => scrollToSection("mission")}
                    >
                        {navContent.mission[language]}
                    </NavLink>

                    <NavLink
                        className={`mobile-link ${activeSection === "contact" ? "active" : ""}`}
                        onClick={() => scrollToSection("contact")}
                    >
                        {navContent.contact[language]}
                    </NavLink>

                    {/* Language Toggle */}
                    <button
                        className="language-toggle mobile-language-toggle"
                        onClick={() => {
                            toggleLanguage();
                            setIsMenuOpen(false);
                        }}
                    >
                        {language === "tamil" ? "Switch to English" : "தமிழுக்கு மாற்று"}
                    </button>

                    <button
                        className="mobile-link highlight"
                        onClick={() => scrollToSection("contact")}
                    >
                        {navContent.joinParty[language]}
                    </button>

                </div>

            </div>
        </nav>
    );
};

export default Navbar;